const declaracao_de_frequencia = [
  {
    path: "/declaracao-de-frequencia",
    redirect: "/declaracao_de_frequencia",
    meta: {
      breadCrumb: "Gestão - Emissão de Documentos",
    },
    children: [
      {
        path: "/declaracao-de-frequencia",
        name: "declaracao_de_frequencia",
        component: () =>
          import("@/views/DeclaracaoDeFrequencia/DeclaracaoDeFrequencia.vue"),
      },
    ],
  },
];

export { declaracao_de_frequencia };
